import React from 'react'

import ScrollableForm from '../components/foundation/ScrollableForm';
import CenteredContentPage from '../components/foundation/CenteredContentPage';
import Footer from '../components/navigation/Footer';

import ContactForm from '../contactpage/ContactForm';

const Contact = () => {

  return (
    <>
        <ScrollableForm>
            <section className="contact-hero-section">
                <CenteredContentPage>
                    <ContactForm/>
                </CenteredContentPage>
            </section>

          <Footer/>
        </ScrollableForm>
    </>
  )
}

export default Contact
